import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

export const api = axios.create({ baseURL: API, withCredentials: true });

api.interceptors.request.use((config) => {
  const t = localStorage.getItem("certy_token");
  if (t) config.headers.Authorization = `Bearer ${t}`;
  const act = localStorage.getItem("certy_act_as");
  if (act) config.headers["X-Act-As"] = act;
  return config;
});
